class CookieManager {
	constructor() {
		this.cookiesAvailable = this.checkCookiesEnabled()
		this.token = this.getCookie('token') || this.getLocalStorage('token')
		this.reservationMenuId = this.getCookie('reservationMenuId') || this.getLocalStorage('reservationMenuId')
		this.cookiesAccepted = (this.getCookie('cookies-accepted') === 'true') || (this.getLocalStorage('cookies-accepted') === 'true')
	}

	checkCookiesEnabled() {
		try {
			document.cookie = 'cookie-test=1; SameSite=Strict'
			const result = document.cookie.indexOf('cookie-test=') !== -1
			document.cookie = 'cookie-test=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
			return result
		} catch (e) {
			return false
		}
	}

	// Métodos para localStorage como fallback
	setLocalStorage(key, value) {
		try {
			localStorage.setItem(key, value)
		} catch (e) {
			return null
		}
	}

	getLocalStorage(key) {
		try {
			return localStorage.getItem(key)
		} catch (e) {
			return null
		}
	}

	removeLocalStorage(key) {
		try {
			localStorage.removeItem(key)
		} catch (e) {
			return null
		}
	}

	// Método unificado para obtener valores (cookies primero, localStorage como fallback)
	getValue(key) {
		const cookieValue = this.getCookie(key)
		if (cookieValue !== null) return cookieValue
		return this.getLocalStorage(key)
	}

	// Método unificado para establecer valores
	setValue(key, value) {
		// Intentar guardar en cookies primero
		if (this.cookiesAvailable) {
			this.setCookie(key, value)
		}
		// Siempre guardar en localStorage como respaldo
		this.setLocalStorage(key, value)
	}

	hasConsent() {
		// Si las cookies están disponibles, usar el valor de cookies
		// Si no, usar localStorage
		return this.cookiesAccepted
	}

	setConsent(value) {
		this.cookiesAccepted = value
		this.setValue('cookies-accepted', value ? 'true' : 'false')
	}

	clearConsent() {
		this.cookiesAccepted = false
		if (this.cookiesAvailable) {
			this.clearCookie('cookies-accepted')
		}
		this.removeLocalStorage('cookies-accepted')
	}

	setCookie(name, value) {
		if (!this.cookiesAvailable) {
			return
		}
		if (name !== 'cookies-accepted' && !this.hasConsent()) {
			return
		}
		const oneHundredYearsInSeconds = 100 * 365 * 24 * 60 * 60
		const date = new Date()
		date.setTime(date.getTime() + oneHundredYearsInSeconds * 1000)
		const expires = '; expires=' + date.toUTCString()

		document.cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value) + expires + '; path=/'
	}

	getCookie(name) {
		if (!this.cookiesAvailable) return null

		const nameEQ = encodeURIComponent(name) + '='
		const ca = document.cookie.split(';')
		for (let i = 0; i < ca.length; i++) {
			let c = ca[i].trim()
			if (c.indexOf(nameEQ) === 0) {
				return decodeURIComponent(c.substring(nameEQ.length))
			}
		}
		return null
	}

	clearCookie(name) {
		if (!this.cookiesAvailable) return
		document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
	}

	getReservationMenuId() {
		return this.getValue('reservationMenuId')
	}

	setReservationMenuId(reservationMenuId) {
		this.reservationMenuId = reservationMenuId
		this.setValue('reservationMenuId', reservationMenuId)
	}

	clearReservationMenuId() {
		this.reservationMenuId = ''
		if (this.cookiesAvailable) {
			this.clearCookie('reservationMenuId')
		}
		this.removeLocalStorage('reservationMenuId')
	}

	getToken() {
		return this.getValue('token')
	}

	setToken(token) {
		this.token = token
		this.setValue('token', token)
	}

	clearToken() {
		this.token = ''
		if (this.cookiesAvailable) {
			this.clearCookie('token')
		}
		this.removeLocalStorage('token')
	}

	// Método para sincronizar localStorage con cookies cuando se habiliten
	syncToCookies() {
		if (!this.cookiesAvailable) return

		// Sincronizar valores importantes
		const token = this.getLocalStorage('token')
		if (token) {
			this.setCookie('token', token)
		}

		const reservationMenuId = this.getLocalStorage('reservationMenuId')
		if (reservationMenuId) {
			this.setCookie('reservationMenuId', reservationMenuId)
		}

		const cookiesAccepted = this.getLocalStorage('cookies-accepted')
		if (cookiesAccepted) {
			this.setCookie('cookies-accepted', cookiesAccepted)
		}
	}
}

export const cookieManager = new CookieManager()
export const cookieConsentBus = new EventTarget()
